import validator from "validator";
import { DataContextProps, DataProviderProps, FormData } from "./types";
import { createContext } from "react";
import { reducer } from "./reducer";
import { funcNotImplemented } from "utils/misc";

import { useState, useEffect, useContext, useReducer } from "react";

const initialData: FormData = {
  name: "",
  brandId: "",
  warranty: [],
};

const DataContext = createContext<DataContextProps>({
  data: initialData,
  isClean: false,
  dispatch: funcNotImplemented,
});

export function DataProvider(props: DataProviderProps) {
  const { children } = props;
  const [data, dispatch] = useReducer(reducer, initialData);
  const [isClean, setIsClean] = useState<boolean>(false);

  useEffect(() => {
    setIsClean(
      !validator.isEmpty(data.name ?? "") &&
        !validator.isEmpty(data.brandId ?? "")
    );
  }, [data]);

  return (
    <DataContext.Provider
      value={{
        data,
        isClean,
        dispatch,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}

export function useDataProvider() {
  return useContext(DataContext);
}
